import { Component } from '@angular/core';
import { DashboardService } from '../../../service/events/dashboard.service';
import { RequestHandler } from '../../../service/OffService/request-handler';
import { Utils } from '../../../common/utils';
import { RequestButtonTypes } from '../../../common/components/request-button/request-button.component';
import { BaseView } from '../../base-view';
import { environment } from '../../../../environments/environment';

import { ConsultasApiService } from 'src/app/service/api/consultas-api.service';

import { ColInterface } from 'src/app/common/components/common-list-table/col.interface';
import { LogModel } from 'src/app/models/log.model';
import { ColStylesInterface } from 'src/app/common/components/common-list-table/col-styles.interface';

import { FormType } from 'src/app/common/components/reactive-form-builder/interfaces/form.interface';
import { ConsultasLogsListModalFormDefinition } from './form-control/list-modal-form-definition';
@Component({
    selector: 'app-consultas-logs',
    standalone: false,
    templateUrl: './consultas-logs.component.html',
    styleUrls: ['./consultas-logs.component.scss']
})
export class ConsultasLogsComponent extends BaseView<LogModel> {
    public form: ConsultasLogsListModalFormDefinition | null = null;
    public serverUrl = environment.serverUrl;


    public getRequest: RequestHandler<LogModel[]> = this.consultasApi.logs.GET;
    public deleteRequest: RequestHandler<LogModel> = this.consultasApi.logs.DELETE;
    public consultas: RequestHandler<LogModel[]> = this.consultasApi.logs.GET;

    public deleteRequestButtonType: RequestButtonTypes = RequestButtonTypes.DELETE;

    public override canShow: Record<string, boolean> = {};
    public override model: LogModel = {usuario: ''};

    public cols: ColInterface[] = [
        {field: 'fecha', header: 'Fecha', filter: ''},
        {field: 'hora', header: 'Hora', filter: ''},
        {field: 'usuario', header: 'Usuario', filter: ''},
        {field: 'ip_origen', header: 'IP', filter: ''},
        {field: 'user_agent', header: 'Navegador', filter: ''},
    ];

    constructor(dashboard: DashboardService,
        private consultasApi: ConsultasApiService) {
        super(dashboard, consultasApi.oscae.GET, undefined);

    }
  
    public globalVisualTransform(value: string){
        return value;
    }

    public globalConditionalStyle(value: string, col: { field: string; }): ColStylesInterface {

        if (Utils.isNumber(value) && col.field === 'rgseaa' ) {
            return {
                textAlign: 'right',
                paddingRight: '70px',
            };
        }
      
        else{
            return {textAlign: 'center'};
        }
    }

    edit(){

    }

    public override show(modal: string, data: LogModel) {
    
        let x;

        this.model = data;
        this.canShow[modal] = true;

        for (x in this.canShow) {
            if (x !== modal && this.canShow[x]) {
                this.canShow[x] = false;
            }
        }
    
        this.setModalForm(modal);
    }

    public override hide(modal: string) {
        this.model = {usuario: ''};
        this.canShow[modal] = false;
        this.deleteRequest.reset();
    }
    private setModalForm(modal: string): void {
        if (modal !== 'info' && modal !== 'delete') {
            return;
        }

        const formType = modal === 'delete' ? FormType.DELETION : FormType.INFORMATIVE;

        this.form = new ConsultasLogsListModalFormDefinition(formType, this.model, this);
    }

}
